export default "__VITE_ASSET__6a5fa21f__"